/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { TextField } from '@mui/material';
import { ReadOnlyTextFieldView } from '../../../shared/views/ReadOnlyTextField.view';

interface Props {
	groupName: string;
	isReadOnlyField?: boolean;
	handleGroupNameChange?: (newGroupName: string) => void;
}

class GroupNameView extends React.Component<Props> {
	constructor(props: Props) {
		super(props);
		this.handleGroupNameChange = this.handleGroupNameChange.bind(this);
	}

	handleGroupNameChange(event: React.ChangeEvent<{ value: string }>): void {
		const { handleGroupNameChange } = this.props;
		handleGroupNameChange && handleGroupNameChange(event.target.value);
	}

	render(): JSX.Element {
		const { groupName, isReadOnlyField } = this.props;
		return isReadOnlyField ? (
			<ReadOnlyTextFieldView
				id="groupName"
				name="groupName"
				label="Gruppename"
				value={groupName}
				InputLabelProps={{ shrink: true }}
				InputProps={{ readOnly: true }}
				fullWidth
			/>
		) : (
			<TextField
				variant="standard"
				required
				id="groupName"
				name="groupName"
				label="Gruppename"
				value={groupName}
				onChange={this.handleGroupNameChange}
				InputLabelProps={{ shrink: true }}
				fullWidth
			/>
		);
	}
}

export default GroupNameView;
